var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaundryGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.559 131.559",
    style: {
      enableBackground: "new 0 0 131.559 131.559"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Laundry_-_Grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M93.501,109.497H38.058 c-2.445,0-4.445-2-4.445-4.445V39.84c0-2.445,2-4.445,4.445-4.445h55.443c2.445,0,4.445,2,4.445,4.445v65.211 C97.946,107.497,95.946,109.497,93.501,109.497z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    cx: 65.78,
    cy: 79.062,
    r: 18
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    x1: 33.613,
    y1: 50.395,
    x2: 97.946,
    y2: 50.395
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 72.581,
    y1: 42.728,
    x2: 78.915,
    y2: 42.728
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 85.248,
    y1: 42.728,
    x2: 91.581,
    y2: 42.728
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M47.78,79.062l6.504,3.01 c2.673,1.237,5.795,1.003,8.253-0.618l7.121-4.696c2.532-1.669,5.761-1.864,8.475-0.512l5.647,2.815"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M113.11,129.559H18.449 C9.364,129.559,2,122.195,2,113.11V18.449C2,9.364,9.364,2,18.449,2h94.662c9.084,0,16.449,7.364,16.449,16.449v94.662 C129.559,122.195,122.195,129.559,113.11,129.559z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundryGrey);
export default __webpack_public_path__ + "static/media/Laundry - Grey.52880c5785573227dfcc6b1e9e7a3d03.svg";
export { ForwardRef as ReactComponent };